function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16 8a1 1 0 00-1-1H3.8l4.9-4.9A.99.99 0 107.3.7L.707 7.293a1 1 0 000 1.414L7.3 15.3a.99.99 0 101.4-1.4L3.8 9H15a1 1 0 001-1z",
  fill: "#29354C"
});

var SvgIconBackBorderDark = function SvgIconBackBorderDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNiA4QzE2IDcuNDQ3NzIgMTUuNTUyMyA3IDE1IDdIMy44TDguNyAyLjFDOS4wODY2IDEuNzEzNCA5LjA4NjYgMS4wODY2IDguNyAwLjdDOC4zMTM0IDAuMzEzNDAxIDcuNjg2NiAwLjMxMzQwMSA3LjMgMC43TDAuNzA3MTA2IDcuMjkyODlDMC4zMTY1ODIgNy42ODM0MiAwLjMxNjU4MyA4LjMxNjU4IDAuNzA3MTA3IDguNzA3MTFMNy4zIDE1LjNDNy42ODY2IDE1LjY4NjYgOC4zMTM0IDE1LjY4NjYgOC43IDE1LjNDOS4wODY2IDE0LjkxMzQgOS4wODY2IDE0LjI4NjYgOC43IDEzLjlMMy44IDlIMTVDMTUuNTUyMyA5IDE2IDguNTUyMjkgMTYgOFoiIGZpbGw9IiMyOTM1NEMiLz4KPC9zdmc+Cg==";
export { SvgIconBackBorderDark as ReactComponent };